export const api = {
    book: process.env.REACT_APP_BOOK_API,
    image: process.env.REACT_APP_IMAGE_API,
    stock: process.env.REACT_APP_STOCK_API,
    order: process.env.REACT_APP_ORDER_API,
    account: process.env.REACT_APP_ACCOUNT_API,
    checkout: process.env.REACT_APP_CHECKOUT_API,
    theme: process.env.REACT_APP_INSTAGRAM_THEME,
    post: process.env.REACT_APP_INSTAGRAM_POST,
    user: process.env.REACT_APP_USER_ADDRESS,
};
